// Have properties order and preferred `z-index` order accordingly
// and make sure it always starts with 1
export const ZIndex = {
    header: 1,
    menu: 2,
};
